import { coreApi } from '$api'
import { ILeaveType, LeaveType } from '$models'

/**
 * Get Leave Types list
 * @returns Promise<ILeaveType[]>
 */
export const getAll = async (staffMemberId?: string): Promise<ILeaveType[]> => {
  const result = await coreApi.getLeaveTypes(staffMemberId)
  return result
}

/**
 * Get Leave Type by Id
 * @param leaveTypeId - leave type id to get
 * @returns Promise<ILeaveType>
 */
export const getById = async (leaveTypeId: string): Promise<ILeaveType> => {
  return await coreApi.getLeaveTypeById(leaveTypeId)
}

/**
 * Update Leave Type
 * @param leaveType - leave type to update
 * @returns Promise<ILeaveType>
 */
export const update = async (leaveType: ILeaveType): Promise<ILeaveType> => {
  const result = await coreApi.updateLeaveType(
    leaveType.id!,
    leaveType as LeaveType
  )
  return result
}

/**
 * Enable Leave Type
 * @param leaveType - leave type to enable
 * @returns Promise<ILeaveType>
 */
export const enable = async (leaveType: ILeaveType): Promise<ILeaveType> => {
  const result = await coreApi.activateLeaveType(
    leaveType.id!,
    leaveType as LeaveType
  )
  return result
}

/**
 * Add Leave Type
 * @param leaveType - leave type to update
 * @returns Promise<ILeaveType>
 */
export const add = async (leaveType: ILeaveType): Promise<ILeaveType> => {
  const newLeaveType = await coreApi.createLeaveType(leaveType as LeaveType)
  return newLeaveType
}

/**
 * Delete Leave Type
 * @param leaveTypeId - leave type id to delete
 * @returns Promise<void>
 */
export const remove = async (leaveTypeId: string): Promise<void> => {
  return await coreApi.deactivateLeaveType(leaveTypeId)
}
